import { useStaticQuery, graphql } from "gatsby"

const useGreenwheatProductQuery = () => {
  const { allDatoCmsGreenwheatProduct } = useStaticQuery(graphql`
    query GreenwheatProducts {
      allDatoCmsGreenwheatProduct(
        filter: {hideForLocale: {ne: true}}, 
        sort: {position: ASC}
      ) {
        nodes {
          id
          originalId
          title
          brand
          slug
          permalink
          header
          size
          category: greenwheatProductCategories {
            title
          }
          gallery {
            ...InternalAssetProps
          }
        }
      }
    }
  `)
  return allDatoCmsGreenwheatProduct.nodes
}

export default useGreenwheatProductQuery